import React, { useEffect, useState, useContext } from "react";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";
import GuideContext from "../GuideContext";

const CompleteGuideButton = ({ className, isProcessing, onClick }) => {
  const guideContext = useContext(GuideContext);
  const classes = classnames('btn', 'btn--complete', 'btn__start', className);

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      disabled={guideContext.isBranchGuide && isProcessing}
      role="button"
      aria-label="Get started on applying for products"
    >
      <FormattedMessage id="summary.getStarted" />
    </button>
  );
};

export default CompleteGuideButton;
